import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { referralService } from '@services/referralService';
import toast from 'react-hot-toast';

export const useReferral = () => {
  const queryClient = useQueryClient();

  const {
    data: info,
    isLoading: isLoadingInfo,
  } = useQuery({
    queryKey: ['referral', 'info'],
    queryFn: referralService.getInfo,
  });

  const {
    data: network = [],
    isLoading: isLoadingNetwork,
  } = useQuery({
    queryKey: ['referral', 'network'],
    queryFn: referralService.getNetwork,
  });

  const {
    data: commissions = [],
    isLoading: isLoadingCommissions,
  } = useQuery({
    queryKey: ['referral', 'commissions'],
    queryFn: referralService.getCommissions,
  });

  const {
    data: withdrawals = [],
    isLoading: isLoadingWithdrawals,
  } = useQuery({
    queryKey: ['referral', 'withdrawals'],
    queryFn: referralService.getWithdrawals,
  });

  const withdrawMutation = useMutation({
    mutationFn: referralService.requestWithdraw,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['referral'] });
      toast.success('Saque solicitado com sucesso!');
    },
    onError: (error) => {
      toast.error(error.response?.data?.error?.message || 'Erro ao solicitar saque');
    },
  });

  return {
    info,
    network,
    commissions,
    withdrawals,
    isLoadingInfo,
    isLoadingNetwork,
    isLoadingCommissions,
    isLoadingWithdrawals,
    requestWithdraw: withdrawMutation.mutateAsync,
    isWithdrawing: withdrawMutation.isPending,
  };
};

export default useReferral;
